import React, { useReducer, useEffect } from 'react';
import { ITextFieldProps, MaskedTextField } from '@fluentui/react';

type Props = { handleError?: (error: string | undefined) => void } & ITextFieldProps;

type Actions = { type: 'setInternalValue'; value?: string };

type State = {
    value?: string;
};

function initialState(value: string): State {
    return { value };
}

const isValueEmpty = (value?: string) => value === '(___) ___-____';
const validatePhone = (phone: string | undefined) => phone && /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phone);

const reducer = (state: State, action: Actions) => {
    switch (action.type) {
        case 'setInternalValue':
            return { ...state, value: action.value };
        default:
            return state;
    }
};

const PhoneField = ({ value, onChange, handleError, ...props }: Props): JSX.Element => {
    const [state, dispatch] = useReducer(reducer, value ? value : '', initialState);

    useEffect(() => {
        if (value !== null && value !== '' && !isValueEmpty(state.value)) dispatch({ type: 'setInternalValue', value });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const onGetErrorMessage = (value: string) => {
        if (isValueEmpty(value)) return undefined;
        const errorPhoneMessage = validatePhone(value) ? undefined : 'Invalid Phone Number';
        if (handleError) handleError(errorPhoneMessage);
        return errorPhoneMessage;
    };

    const handleChange = (e: React.FormEvent<HTMLTextAreaElement | HTMLInputElement>, value?: string) => {
        dispatch({ type: 'setInternalValue', value });
        if (value && onChange) {
            if (validatePhone(value)) {
                onChange(e, value);
            } else {
                onChange(e, '');
            }
            if (isValueEmpty(state.value)) {
                onChange(e, '');
            }
        }
    };

    return (
        <MaskedTextField
            {...props}
            onChange={handleChange}
            value={state.value}
            mask="(999) 999-9999"
            onGetErrorMessage={onGetErrorMessage}
            validateOnFocusOut
            validateOnLoad={value ? true : false}
        />
    );
};

export default PhoneField;
